export default __webpack_public_path__ + "static/media/MLion.5e254a1c.png";